import React from 'react';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import SuperPaymentForm from '../components/SuperPaymentForm';
import FormTextField from '../components/FormTextField';
import { useAppSelector } from '../app/hooks';
import { OrderingConstants, OrderingSelectors } from 'polygon-ordering';
import PaymentProvider from '../components/PaymentProvider';
import { TyroProvider } from '../hooks/TyroProvider';

const { getGatewayType } = OrderingSelectors;
const { PAYMENT_GATEWAY_TYPES } = OrderingConstants;

export const GIFT_CARD_TOP_UP_ROUTE = '/gift-card-top-up';

const GiftCardTopUp = () => {
  const { t } = useTranslation();
  const gatewayType = useAppSelector(getGatewayType);
  const handleFormSubmit = () => {};

  const schemas = {
    MemberNo: Yup.string().required(t('form.required')),
    VerifyPIN: Yup.string().required(t('form.required')),
    Amount: Yup.number().required(t('form.required')),
  };

  const validationSchema = Yup.object().shape(schemas);

  const fields = [
    {
      name: 'MemberNo',
      type: 'text',
      label: t('placeholder.giftCardNo'),
      required: true,
    },
    {
      name: 'VerifyPIN',
      type: 'text',
      label: t('placeholder.verifyPin'),
      required: true,
    },

    {
      name: 'Amount',
      type: 'number',
      label: t('placeholder.giftcardAmount'),
      required: true,
    },
  ];

  let PaymentProviderWrapper: any;

  if (gatewayType === PAYMENT_GATEWAY_TYPES.STRIPE) {
    PaymentProviderWrapper = PaymentProvider;
  } else if (gatewayType === PAYMENT_GATEWAY_TYPES.TYRO) {
    PaymentProviderWrapper = TyroProvider;
  }

  return (
    <div className="text-center py-2">
      <Formik
        validationSchema={validationSchema}
        initialValues={{ MemberNo: '', VerifyPIN: '', Amount: '' }}
        onSubmit={handleFormSubmit}
      >
        {({ handleSubmit, handleChange }) => (
          <Form onSubmit={handleSubmit}>
            {fields.map(field => (
              <FormTextField
                key={field.name}
                type={field.type}
                name={field.name}
                label={field.label}
                required={field.required}
                onChange={e => {
                  handleChange(e);
                }}
              />
            ))}
            <PaymentProviderWrapper>
              <SuperPaymentForm route="giftCardTopUp" />
            </PaymentProviderWrapper>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default GiftCardTopUp;
